<template>
  <div
    v-show="reservationLoading"
    :class="{ 'no-logo': !showLogo, 'no-content': !showContent }"
    :style="bgStyle"
    class="cc-live clearfix"
  >
    <div v-if="showContent" class="app-content">
      <div :style="nameStyle" class="app-name">
        {{ liveName || '此处为直播信息' }}
      </div>
      <div class="app-desc">
        <div :style="descStyle" class="app-text">
          {{ live.text || defaultApp.description || '此处为直播描述，直播描述内容支持一行显示' }}
        </div>
      </div>
    </div>
    <div v-else-if="!bgStyle" class="empty">
      <img src="../../assets/image_empty.png" alt="" />
    </div>
    <template v-if="showLogo">
      <img v-if="live.logo" :src="webpSafe(live.logo)" class="app-logo" />
      <div v-else class="app-logo empty" />
    </template>
    <div class="app-button">
      <LiveButtonComp
        :class="buttonClass"
        :style="buttonStyle"
        :isClient="isClient"
        :event="event"
        :live="live"
        :reservationId="reservationId"
      />
    </div>
  </div>
</template>
<script>
import LiveButtonComp from './LiveButton'
import { webpSafe } from '../utils'
import { getQuery } from '@/utils'
import { baseOpenURL } from '@/config'
import { inBiliApp } from '@bilibili/js-bridge'

function formatDate(timestamp, format = 'MM-DD HH:mm') {
  const date = new Date(Number(timestamp * 1000))
  const pad = (n) => n.toString().padStart(2, '0')
  return format
    .replace('YYYY', date.getFullYear())
    .replace('MM', pad(date.getMonth() + 1))
    .replace('DD', pad(date.getDate()))
    .replace('HH', pad(date.getHours()))
    .replace('mm', pad(date.getMinutes()))
    .replace('ss', pad(date.getSeconds()))
}

export default {
  name: 'CcLive',
  components: {
    LiveButtonComp
  },
  created() {
    if (this.isClient && this.data?.live?.reservation?.reservationId) {
      this.getDetail(this.data?.live?.reservation?.reservationId)
    } else {
      this.reservationLoading = true
    }
    // this.getDetail(this.data?.live?.reservation?.reservationId)
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    showContent: {
      type: Boolean,
      default: true
    },
    defaultApp: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      webpSafe,
      reservationLoading: false,
      event: {
        title: '',
        desc: '',
        stime: '',
        is_follow: 0,
        can_follow: 1
      },
      isClient: !!inBiliApp
    }
  },
  computed: {
    live() {
      return this.data?.live || {}
    },
    liveName() {
      if (this.isClient) {
        if (this.event.stime) {
          return `${formatDate(this.event.stime)} 开始直播`
        } else {
          return ''
        }
      } else {
        const { reservationTime = '' } = this.data?.live?.reservation || {}
        if (reservationTime) {
          return `${formatDate(reservationTime)} 开始直播`
        } else {
          return '开始直播'
        }
      }
    },
    compStyle() {
      return this.data?.compStyle || {}
    },
    nameStyle() {
      const { nameColor: color } = this.compStyle
      return {
        color
      }
    },
    descStyle() {
      const { descColor: color } = this.compStyle
      return {
        color
      }
    },
    bgStyle() {
      const { background } = this.compStyle || {}
      const style = {
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }

      if (/^http(s)?:\/\//.test(background)) {
        style.backgroundImage = `url(${webpSafe(background)})`
      } else {
        style.backgroundColor = background
      }

      return background ? style : null
    },
    buttonStyle() {
      const overrideStyle = {}
      // 审核时下载组件标注
      if (getQuery('is_audit')) {
        overrideStyle.borderColor = 'red'
        overrideStyle.borderWidth = '2px'
      }
      const { borderWidth, borderRadius, fontSize, ...rest } = this.data?.buttonStyle || {}

      return {
        borderRadius: borderRadius + 'px',
        borderWidth: borderWidth + 'px',
        fontSize: fontSize + 'px',
        ...rest,
        ...overrideStyle
      }
    },
    buttonClass() {
      const { animation } = this.data?.buttonStyle || {}
      return `animation-${animation}`
    },
    reservationId() {
      return this.data?.live?.reservation?.reservationId || ''
    }
  },
  methods: {
    getDetail(query) {
      const mid = window?.alita?.appInfo?.mid || ''
      const data = {
        sid: query
      }
      if (mid) {
        data.mid = mid
      }
      this.$request
        .get('v1/landing_pages/query/reserve', data, {
          baseURL: baseOpenURL,
          checkStatus: false
        })
        .then(({ data, code }) => {
          this.reservationLoading = true
          if (+code === 0) {
            const { title = '', desc = '', stime = '', is_follow = 0, can_follow = 1 } = data || {}
            this.event.title = title
            this.event.desc = desc
            this.event.stime = stime
            this.event.is_follow = is_follow
            this.event.can_follow = can_follow
          } else {
            this.event.can_follow = 0
          }
        })
        .catch(() => {
          this.event.can_follow = 0
          this.reservationLoading = true
          this.reservationOptions = []
          this.reservationDataOptions = []
        })
    }
  }
}
</script>
<style lang="less" scoped>
.cc-live {
  width: 343px;
  height: 54px;
  box-sizing: border-box;
  padding: 10px 10px;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  border-radius: 8px;
  overflow: hidden;
  .app-logo {
    float: left;
    width: 34px;
    height: 34px;
    margin-left: -100%;
    border-radius: 50%;
    &.empty {
      background-color: #f5f5f5;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 22px 16px;
      background-image: url('../../assets/image_empty.png');
    }
  }
  .app-content {
    float: left;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0 100px 0 43px;
    .app-name {
      color: #333;
      font-size: 13px;
      line-height: 14px;
      margin-bottom: 4px;
      font-weight: 500;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .app-desc {
      display: flex;
      width: 100%;
      justify-content: flex-start;
      align-items: flex-end;
      height: 14px;
      .app-text {
        display: -webkit-box;
        -webkit-box-orient: block-axis;
        -webkit-line-clamp: 1;
        max-height: 28px;
        word-break: break-all;
        overflow: hidden;
        line-height: 14px;
        color: #666;
        font-size: 12px;
      }
    }
  }
  .app-button {
    float: right;
    width: 72px;
    height: 24px;
    margin: 5px 0 3px -80px;
  }
}
</style>
